var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreHoriz({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.841-386Q165-386 137.5-413.659q-27.5-27.66-27.5-66.5Q110-519 137.659-546.5q27.66-27.5 66.5-27.5Q243-574 270.5-546.341q27.5 27.66 27.5 66.5Q298-441 270.341-413.5q-27.66 27.5-66.5 27.5Zm276 0Q441-386 413.5-413.659q-27.5-27.66-27.5-66.5Q386-519 413.659-546.5q27.66-27.5 66.5-27.5Q519-574 546.5-546.341q27.5 27.66 27.5 66.5Q574-441 546.341-413.5q-27.66 27.5-66.5 27.5Zm276 0Q717-386 689.5-413.659q-27.5-27.66-27.5-66.5Q662-519 689.659-546.5q27.66-27.5 66.5-27.5Q795-574 822.5-546.341q27.5 27.66 27.5 66.5Q850-441 822.341-413.5q-27.66 27.5-66.5 27.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHoriz);
export default __webpack_public_path__ + "static/media/more_horiz.aecbf5969b73cca993bc4576f51b5b1b.svg";
export { ForwardRef as ReactComponent };